
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setSupplierDeliveryDate = (supplierDeliveryDate: libTypes.Order['supplierDeliveryDate']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.supplierDeliveryDate = fns.order.set.supplierDeliveryDate(supplierDeliveryDate);
        })
    });
};